export default "__VITE_ASSET__jFK50XGo__"